/** Hub control-room column; matches workbench thread max width (44rem). */
export const PROJECT_HUB_COLUMN_CLASS = "mx-auto w-full max-w-[44rem]";

export const PROJECT_HUB_NAV_MT = "mt-3";

export const PROJECT_HUB_CONTENT_MT = "mt-4";

/** Tighter nav spacing on project home (composer-first layout). */
export const PROJECT_HUB_HOME_NAV_MT = "mt-2";

/** Tighter content spacing below nav on project home. */
export const PROJECT_HUB_HOME_CONTENT_MT = "mt-2";
